import { render, staticRenderFns } from "./CfgGrupoFilial.vue?vue&type=template&id=3f894ddd&scoped=true&"
import script from "./CfgGrupoFilial.vue?vue&type=script&lang=js&"
export * from "./CfgGrupoFilial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f894ddd",
  null
  
)

export default component.exports